import React, { useReducer, useContext, createContext } from "react";

export const initialState = {
    querySearch: '',
    queryFilters: {},
    searchResults: [],
    loading: false,
    validationDate: null,
    comparatorHistoricalRange: null,
}

const reducer = (searchParamsState, action) => {
    return { ...searchParamsState, ...action };
}

export const SearchParamsContext = createContext();
export const SearchParamsDispatchContext = createContext();

export const SearchParamsProvider = ({ children }) => {
    const [searchParamsState, searchParamsDispatch] = useReducer(reducer, initialState);

    return (
        <SearchParamsContext.Provider value={searchParamsState}>
            <SearchParamsDispatchContext.Provider value={searchParamsDispatch}>
                {children}
            </SearchParamsDispatchContext.Provider>
        </SearchParamsContext.Provider>
    );
};

export function useSearchParams() {
    return useContext(SearchParamsContext);
}

export function useSearchParamsDispatch() {
    return useContext(SearchParamsDispatchContext);
}
